import React from "react";
import "./Recfacilities.css"; 
import './Recfacilities.css'; // Import CSS styles

const RecFacilities = () => {
  const courses = [
    { title: "Swimming Pool", description: "Experience the ultimate relaxation and refreshment in our stunning outdoor swimming pool, where luxury meets tranquility under the open sky.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1739459187/Untitled_design_36_dzkvh6.webp", link: "/engineering-details" },
    { title: "Kids Zone", description: "Kids Zone: A dedicated play area for children, ensuring fun for the whole family.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735985986/2_uo4vjy.svg", link: "/management-details" },
    { title: "Garden", description: "Gardens: Enjoy the calm and beauty of our lush green garden, perfect for relaxing walks or outdoor events. It's a peaceful spot to connect with nature.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1739458830/Untitled_design_34_amkg0f.svg", link: "/computer-applications-details" },
  ];

  return (
    <div className="courses-container">
      <div className="courses-heading">
        <h2>Dive into Luxury & Fun</h2>
        <p>"At The Golden Palace, leisure and relaxation are our priorities. Discover a
        range of recreational activities to make your stay memorable."</p>
      </div>
      <div className="courses-offer">
        {courses.map((course, index) => (
          <div className="course-card" key={index}>
            <div className="card-content">
              <div className="background-image" style={{ backgroundImage: `url(${course.image})` }}></div>
              <div className="course-info">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>
                {/* <a href={course.link} className="course-button">Learn More</a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecFacilities;
